import React, { useState, useEffect, useMemo, useRef } from "react";
import {
    TextField,
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Paper,

} from "@mui/material";
import { useLazyGetAllPlanListQuery } from "../../../slices/planApi";

const PlanModal = ({ open, onClose, initialData, onSubmit }) => {
    const [triggerGetPlans, { data: planList, isLoading }] = useLazyGetAllPlanListQuery();

    const [formData, setFormData] = useState({

    });

    useEffect(() => {
        if (open) {
            triggerGetPlans({ page: 1, limit: 10, search: "" });
        }
    }, [open, triggerGetPlans]);



    const handleSubmit = async () => {

        await onSubmit(formData);

    };

    const handleClose = () => {
        onClose();

    };

    return (
        <Dialog open={open} onClose={handleClose}>
            <DialogTitle>{"Update Plan"}</DialogTitle>
            <DialogContent dividers>
                {isLoading ? (
                    <p>Loading plans...</p>
                ) : (
                    <TableContainer component={Paper}>
                        <Table>
                            <TableHead>
                                <TableRow>
                                    <TableCell>Plan Name</TableCell>
                                    {/* <TableCell>Price</TableCell> */}
                                    <TableCell>QR</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {planList?.plans?.map((plan) => (
                                    <TableRow key={plan.id}>
                                        <TableCell>{plan.name}</TableCell>
                                        {/* <TableCell>{plan.price}</TableCell> */}
                                        <TableCell>{plan.qr_box}</TableCell>
                                    </TableRow>
                                ))}
                            </TableBody>
                        </Table>
                    </TableContainer>
                )}
            </DialogContent>
            <DialogActions>
                <Button onClick={handleClose} color="secondary">
                    Cancel
                </Button>
                <Button onClick={handleSubmit} color="primary" variant="contained">
                    {"Update"}
                </Button>
            </DialogActions>
        </Dialog >
    );
};

export default PlanModal;
